import React from 'react'
import Div from '../Div'
import Swal from '../../utils/darkSwal';
import BASE_URL from '../../utils/api';
import axios from 'axios';

export default function Newsletter({title, subtitle, placeholder}) {
  const [email, setEmail] = React.useState('');
  
  // Simple email validation function
  const validateEmail = (email) => {
    // Basic regex for email validation
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateEmail(email)) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid Email',
        text: 'Please enter a valid email address.',
        confirmButtonColor: '#1344af',
      });
      return;
    }

    try {
      // Replace with your backend endpoint
      const response = await axios.post(`${BASE_URL}/api/subscribeMails`, { email });
      Swal.fire({
        icon: 'success',
        title: 'Subscribed!',
        text: 'You have been subscribed to the newsletter.',
        confirmButtonColor: '#1344af',
      });
      setEmail('');
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response?.data?.message || 'Something went wrong. Please try again.',
        confirmButtonColor: '#1344af',
      });
    }
  };

  return (
    <>
      {title && <h2 className="cs-widget_title">{title}</h2>}
      <Div className="cs-newsletter cs-style1">
        <form className="cs-newsletter_form" onSubmit={handleSubmit}>
          <input
            type="email"
            className="cs-newsletter_input"
            placeholder={placeholder}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button className="cs-newsletter_btn" type="submit">
            <span>Send</span>
          </button>
        </form>
        <Div className="cs-newsletter_text">{subtitle}</Div>
      </Div>
    </>
  )
}
